<template>
  <div id="grid-contingencia">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="newContingencia()"
              >Agregar Contingencia</v-btn
            >
          </v-card-actions>
          <v-container>
            <v-layout class="d-flex pa-2">
              <div class="d-flex pa-2" xs12 sm6>
                <v-text-field
                  width="300px"
                  v-model="txtBusqueda"
                  placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
                  single-line
                ></v-text-field>
                <v-btn
                  color="primary"
                  @click="loadDataContingencia()"
                  :disabled="txtBusqueda.length < 3"
                  class="shrink"
                  ><v-icon dark left>search</v-icon>Buscar</v-btn
                >
                <v-btn
                  color="secondary"
                  @click="limpiaBuscador()"
                  :disabled="txtBusqueda.length < 3"
                  class="shrink"
                  ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
                >
              </div>
            </v-layout>
          </v-container>
          <v-data-table
            :headers="headers"
            :items="itemsContingencia"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
              <td class="text-xs-left">
                {{ props.item.estadoContingencia.descripcion }}
              </td>
              <td class="text-xs-left">{{ props.item.author }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver estados de la contingencia"
                  @click="viewContingencia(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  v-if="tipoUsuario == props.item.accion"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar contingencia"
                  @click="editContingencia(props.item.id)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA USUARIO -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn depressed outline icon fab dark color="green darken-4" small>
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Ver contingencia
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >&nbsp;Editar contingencia
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
export default {
  name: "grid-contingencia",
  components: {
    Loading,
  },
  props: {
    itemsDocumento: {},
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      loading: false,
      contratoId: "",
      itemsProgreso: [],
      tipoUsuario: this.$store.getters.userLogged.tipo,
      headers: [
        { text: "ID Contingencia", sortable: false, value: "idContingencia" },
        { text: "Fecha Inicio", sortable: false, value: "fechaInicio" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Autor", sortable: false, value: "autor" },
        { text: "Accion", sortable: false, value: "" },
      ],
      itemsContingencia: [],
    };
  },
  created() {
    this.contratoId = this.$store.getters.contratoStored;
  },

  mounted() {
    if (
      this.contratoId != null &&
      this.contratoId != "" &&
      this.contratoId !== undefined
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    }

    this.loadDataContingencia();
  },
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadDataContingencia() {
      this.loading = true;
      this.itemsContingencia = await this.loadContingenciaByContract();
      this.miPaginacion.totalItems = this.itemsContingencia.length;
      if (this.itemsContingencia.length > 0) {
        this.$parent.$parent.alerta = false;
      } else {
        this.$parent.$parent.alerta = true;
      }
      this.loading = false;
    },

    async loadContingenciaByContract() {
      this.body = {
        idContrato: this.contratoId,
        subProceso: this.$store.getters.subProTabSelectedStored,
        txtBusqueda: this.txtBusqueda,
      };
      return await axios
        .post("/contingencias/filtro", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadDataContingencia();
    },
    editContingencia(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContingenciaRegistraMecanizado",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },

    viewContingencia(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContingenciaRegistraMecanizado",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },

    newContingencia() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContingenciaRegistra",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },

    viewDocument(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContingenciaRegistra",
          params: { documentoId: id, tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
